import { Analytics } from "@vercel/analytics/react"
import { ReactNode } from "react"
import "../../styles/template.scss"

interface TemplateProps {
  className: string
  children: ReactNode
}

export function Template({ className, children, ...rest }: TemplateProps) {
  return (
    <main className={`template ${className}`} {...rest}>
      {children}
      <Analytics />
    </main>
  )
}
